// extracted by mini-css-extract-plugin
module.exports = {"thank":"Thank_thank__3mfQs","tnankTitle":"Thank_tnankTitle__iZBwD","thankText":"Thank_thankText__2UkFK"};